import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Accordion } from '@theneatcompany/nui'
import sortBy from 'lodash/sortBy'

const monthsSortOrder = {
  January: 12,
  February: 11,
  March: 10,
  April: 9,
  May: 8,
  June: 7,
  July: 6,
  August: 5,
  September: 4,
  October: 3,
  November: 2,
  December: 1,
}

const sortYearKeys = years => [...years].sort((a, b) => b - a)
const sortMonthKeys = months => sortBy(months, m => monthsSortOrder[m])

const getFirstMonth = (data, year) => {
  if (!year || !data[year]) return null
  return sortMonthKeys(Object.keys(data[year]))[0] ?? null
}

export default function YearMonthAccordion({ data = {}, renderContent, className, monthClassName }) {
  const sortedYears = sortYearKeys(Object.keys(data))
  const firstYear = sortedYears[0] ?? null
  const [expandedYear, setExpandedYear] = useState(firstYear)
  const [expandedMonth, setExpandedMonth] = useState(() => getFirstMonth(data, firstYear))

  useEffect(() => {
    setExpandedMonth(getFirstMonth(data, expandedYear))
  }, [expandedYear, data])

  if (!sortedYears.length) return null

  return (
    <div className={className}>
      {sortedYears.map((year) => {
        const months = data[year]
        if (!months || !Object.keys(months).length) return null
        const isYearExpanded = expandedYear === year
        return (
          <Accordion
            key={year}
            isExpanded={isYearExpanded}
            label={year}
            onClick={() => {
              setExpandedMonth(null)
              setExpandedYear(isYearExpanded ? null : year)
            }}
            size="large"
          >
            {sortMonthKeys(Object.keys(months)).map((month) => {
              const isMonthExpanded = expandedMonth === month
              return (
                <Accordion
                  key={month}
                  className={monthClassName}
                  isExpanded={isMonthExpanded}
                  label={month}
                  onClick={() => setExpandedMonth(isMonthExpanded ? null : month)}
                >
                  {isMonthExpanded && renderContent(months[month])}
                </Accordion>
              )
            })}
          </Accordion>
        )
      })}
    </div>
  )
}

YearMonthAccordion.propTypes = {
  data: PropTypes.objectOf(PropTypes.objectOf(PropTypes.shape({}))).isRequired,
  renderContent: PropTypes.func.isRequired,
  className: PropTypes.string,
  monthClassName: PropTypes.string,
}
